import React, { useContext, useEffect } from 'react';
import authContext from '../context/auth/authContext';
import Login from '../componentes/login/login';
import { useDispatch, useSelector } from 'react-redux';
import { UIActions } from '../presentation/redux/actions/UIActions';
import { getBalanceUseCase, getIpUseCase } from '../di/usecase_module';
import { GetBalanceRequestDto } from '../domain/usecases/balance/GetBalanceUseCase';
import { sessionLocalRepo } from '../di/repo_module';
import { applog } from '../domain/utils/applog';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { PublicRoutes } from './PublicRoutes';
import { PrivateRoutes } from './PrivateRoutes';
import { LoginLoader } from '../componentes/login/LoginLoader';
import { PassRecovery } from '../componentes/login/PassRecovery';
import { PassRecoveryUpdate } from '../componentes/login/PassRecoveryUpdate';
import { PassRecoveryUpdateApp } from '../componentes/login/PassRecoveryUpdateApp';
import { DashboardRoutes } from './DashboardRoutes';
import { UpdatePassword } from '../componentes/login/UpdatePassword';
import { Emailverify } from '../componentes/login/Emailverify';

export const AppRouter = ({ ...props }) => {

    const AuthContext = useContext(authContext);
    const { autenticado, iniciarSesion } = AuthContext;

    /* const uiState = useSelector((s: RootState) => s.uiState); */
    const { isLoginCheckLoading } = useSelector(s => s.uiState);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(UIActions.setLoaginCheckLoading(true));
        getIp();
        loginChecking();
    }, [dispatch]);


    const loginChecking = () => {
        const auth = localStorage.getItem("auth")
        if (auth) {
            const data = JSON.parse(auth)
            getBalanceUseCase().execute(new GetBalanceRequestDto(data.token))
                .then((_) => {
                    iniciarSesion(data);
                    dispatch(UIActions.setLoaginCheckLoading(false));
                }).catch((_) => {
                    sessionLocalRepo().clearSession();
                    localStorage.removeItem("auth");
                    dispatch(UIActions.setLoaginCheckLoading(false));
                })
        } else {
            dispatch(UIActions.setLoaginCheckLoading(false));
        }
    }

    const getIp = () => {
        getIpUseCase().execute()
            .then((result) => {
                applog("IP OBTENIDA =>", result);
            }).catch((error) => {
                applog("IP OBTENIDA ERROR =>", error);
            });

        if ("geolocation" in navigator) {
            applog("GEO", "Available");
            navigator.geolocation.getCurrentPosition(function (position) {
                sessionLocalRepo().lat = position.coords.latitude;
                sessionLocalRepo().lng = position.coords.longitude
            });
        } else {
            applog("GEO", "Not Available");
        }
    }

    if (isLoginCheckLoading) {
        return (<LoginLoader />);
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path='/emailverify' element={
                    <Emailverify />
                }
                />
                <Route path='/login' element={
                    <PublicRoutes isAuthenticate={!!autenticado}>
                        <Login {...props} />
                    </PublicRoutes>
                }
                />
                <Route path='/passrecovery' element={
                    <PublicRoutes isAuthenticate={!!autenticado}>
                        <PassRecovery />
                    </PublicRoutes>
                }
                />
                <Route path='/passrecoveryupdate' element={
                    <PublicRoutes isAuthenticate={!!autenticado}>
                        <PassRecoveryUpdate />
                    </PublicRoutes>
                }
                />
                <Route path='/passrecoveryupdateapp' element={
                    <PublicRoutes isAuthenticate={!!autenticado}>
                        <PassRecoveryUpdateApp />
                    </PublicRoutes>
                }
                />
                <Route path='/*' element={
                    <PrivateRoutes isAuthenticate={!!autenticado}>
                        <DashboardRoutes />
                    </PrivateRoutes>
                }
                />
                <Route path='/updatepassword' element={
                    <PrivateRoutes isAuthenticate={!!autenticado}>
                        <UpdatePassword />
                    </PrivateRoutes>
                }
                />
            </Routes>
        </BrowserRouter>
    )
}